import { Injectable } from "@angular/core";
import { GLOBAL } from './global';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Socket } from 'ngx-socket-io';
import * as uuid from 'uuid';
import { SocketPagosService } from "./socket-pagos.service";

@Injectable()
export class PagoService {

  public url;
  public identity;
  public token;
  public pago_portal
  public pago_finalizado;
  public pago_nuevonumero;
  public disconnect;
  public myId = uuid.v4();

  constructor(private _http: HttpClient, private socket: SocketPagosService) {
    this.url = GLOBAL.url;
    this.pago_portal = this.socket.fromEvent<any>('pago_portal');
    this.pago_finalizado = this.socket.fromEvent<any>('pago_finalizado');
    this.disconnect = this.socket.fromEvent<any>('disconnect');
    this.pago_nuevonumero = this.socket.fromEvent<any>('pago_nuevonumero')
  }

  desconetar(value) {
    console.log("entre en desconectar socket")
    // this.socket.emit('disconnect', { value: value })
    this.socket.emit('salirSocket')
  }


  newPagoSMC(Myid, carro, user, taller, dirs, valor_cert, pago, tipo) {
    console.log("entre en newpagosmc")
    console.log(carro)
    console.log(this.socket)
    this.socket.emit('nuevo_pago', { id: Myid, pago: carro, user: user, taller: taller, dirs: dirs, valor_cert: valor_cert, monto: pago, tipo: tipo })
  }

  newPagoDerecho(id, carro, infoDerecho, user, valorDerecho, departamento) {
    console.log("valor del derecho", valorDerecho)
    console.log(carro)
    console.log(this.socket)
    this.socket.emit('nuevo_pago_derecho', { id: id, pago: carro, info: infoDerecho, user: user, valor: valorDerecho, departamento: departamento })
  }

  newPagoCertificado(id, carro, infoCerts, infoRut, valorTotal, dirs, datos) {
    // console.log("valor del derecho", valorDerecho)
    console.log(carro)
    console.log(this.socket)
    this.socket.emit('nuevo_pago_certificados', { id: id, pago: carro, info: infoCerts, inforut: infoRut, valorTotal: valorTotal, dirs: dirs, datos: datos })
  }
  


  generateGiro(id, carro, infoCerts, infoRut, valorTotal, dirs, datos) {
    const params = {
      id: id,
      pago: carro,
      info: infoCerts,
      inforut: infoRut,
      valorTotal: valorTotal,
      dirs: dirs,
      datos: datos
    }

    let headers = new HttpHeaders({
      'Content-type': 'application/json',
    })

    console.log(`${this.url}cert/giro`)

    return this._http.post(`${this.url}cert/giro`, params, { headers: headers })
    
  }

  generateGiroExpediente(id, carro, infoDerecho, user, valorDerecho, departamento) {
    const params = { id: id, pago: carro, info: infoDerecho, user: user, valor: valorDerecho, departamento: departamento }

  console.log("hola", this.generateGiroExpediente)
    let headers = new HttpHeaders({
      'Content-type': 'application/json',
    })

    console.log(`${this.url}expediente/giro`)

    return this._http.post(`${this.url}expediente/giro`, params, { headers: headers })
  }

}